export default {
    accesos: [
        { route: 'dashboard', modulo: '' },
        { route: '', modulo: 'DashboardVentas' },
        { route: '', modulo: 'DashboardRentabilidadNeta' },
        { route: '', modulo: 'DashboardHistorico' },
        { route: '', modulo: 'DashboardCuentas' },
        { route: '', modulo: 'DashboardAdministracion' },
        { route: '', modulo: 'DashboardProduccion' },

        { route: 'compras', modulo: '' },
        { route: 'compras/compras', modulo: '' },
        { route: 'compras/compras/viaticos/:viaticoId/add', modulo: '' },

        { route: 'proveedores', modulo: '' },
        { route: 'proveedores/proveedores', modulo: '' },
        { route: 'proveedores/proveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id', modulo: '' },
        { route: 'proveedores/ordenesproveedores/:id/ABM', modulo: '' },
        { route: 'proveedores/ordenesproveedores/orden-interna', modulo: '' },

        { route: 'rrhh', modulo: '' },
        { route: 'rrhh/personal', modulo: '' },
        { route: 'rrhh/personal/add', modulo: '' },
        { route: 'rrhh/personal/:id/edit', modulo: '' },
        { route: 'rrhh/personal/:id', modulo: '' },
        { route: '', modulo: 'PersonalDatosNovedades' },
        { route: '', modulo: 'PersonalDatosVacaciones' },
        { route: 'rrhh/liquidaciones-sueldos', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/add', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/:id', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/:id/edit', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/liquidacion-final/add', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/liquidacion-final/:id/edit', modulo: '' },
        { route: 'rrhh/liquidaciones-sueldos/:liquidacionSueldosId/pago', modulo: '' },
        { route: 'rrhh/novedades', modulo: '' },
        { route: 'rrhh/novedades/add', modulo: '' },
        { route: 'rrhh/novedades/:id', modulo: '' },
        { route: 'rrhh/novedades/:id/edit', modulo: '' },
        { route: 'rrhh/novedades/vacaciones/add', modulo: '' },
        { route: 'rrhh/novedades/vacaciones/:id/edit', modulo: '' },
        { route: 'rrhh/novedades-calendario', modulo: '' },
        { route: 'rrhh/viaticos', modulo: '' },
        { route: 'rrhh/viaticos/add', modulo: '' },
        { route: 'rrhh/viaticos/:id', modulo: '' },
        { route: 'rrhh/viaticos/:id/edit', modulo: '' },
        { route: '', modulo: 'ViaticosAutorizacion' },
        { route: '', modulo: 'ViaticosComprobantes' },
        { route: '', modulo: 'ViaticosSeleccionPersonal' },
        { route: '', modulo: 'ViaticosPagos' },
        { route: 'rrhh/encuestas', modulo: '' },
        { route: 'rrhh/encuestas/:id', modulo: '' },
        { route: 'rrhh/encuestas/:id/completar', modulo: '' },

        { route: 'tablas', modulo: '' },
        { route: 'tablas/tipos-novedades', modulo: '' },
        { route: 'tablas/tipos-novedades/:id', modulo: '' },
        { route: 'tablas/tipos-novedades/:id/ABM', modulo: '' },
        { route: 'tablas/viaticos-rubros', modulo: '' },
        { route: 'tablas/viaticos-rubros/add', modulo: '' },
        { route: 'tablas/viaticos-rubros/:id/edit', modulo: '' },
        { route: 'tablas/viaticos-rubros/:id', modulo: '' },

        { route: 'reportes', modulo: '' },
        { route: 'reportes/rrhh', modulo: '' },
        { route: 'reportes/rrhh/evolucion-sueldos', modulo: '' }
    ]
}
